import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PermitDetail } from '../../../models/permit-detail.model';

/** Media permit detail - common fields plus the project details. */
@Component({
    selector: 'app-media-detail',
    templateUrl: './media-detail.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MediaDetailComponent {
    @Input() permit!: PermitDetail;
}
